// @ts-nocheck

import * as Apollo from "@apollo/client";

import gql from "graphql-tag";
import * as APITypes from "../../apiTypes";
import { PaymentFragmentDoc } from "./fragments.generated";

const defaultOptions = {} as const;
export type CreatePaymentMethodMutationVariables = APITypes.Exact<{
  paymentMethodToken: APITypes.Scalars["String"]["input"];
}>;

export type CreatePaymentMethodMutation = { createPaymentMethod: string };

export type CheckoutPaymentVerificationMutationVariables = APITypes.Exact<{
  input: APITypes.VerifyCheckoutPaymentMethodInput;
}>;

export type CheckoutPaymentVerificationMutation = {
  checkoutPaymentVerification: {
    requiresAdditionalActions: boolean;
    confirmed: boolean;
    nextStep?: {
      clientSecret: string;
      paymentIntentId: string;
      redirectUrl: string;
      type: APITypes.PaymentActionType;
    } | null;
  };
};

export type RemovePaymentMethodMutationVariables = APITypes.Exact<{
  paymentMethodId: APITypes.Scalars["String"]["input"];
}>;

export type RemovePaymentMethodMutation = { removePaymentMethod: boolean };

export type AuthorizePaymentMutationVariables = APITypes.Exact<{
  paymentId: APITypes.Scalars["String"]["input"];
}>;

export type AuthorizePaymentMutation = {
  authorizePayment: {
    amount: number;
    appliedDiscount: number;
    currency: string;
    id: string;
    paymentMethodId?: string | null;
    paymentUpdateDate?: string | null;
    status: APITypes.PaymentStatus;
    stripePaymentNextStep?:
      | {
          clientSecret: string;
          paymentIntentId: string;
          redirectUrl: string;
          type: APITypes.PaymentActionType;
        }
      | {
          clientSecret: string;
          paymentIntentId: string;
          stripeSdkData: string;
          type: APITypes.PaymentActionType;
        }
      | null;
  };
};

export type RetryPaymentMutationVariables = APITypes.Exact<{
  paymentId?: APITypes.InputMaybe<APITypes.Scalars["String"]["input"]>;
  stripePaymentMethodId: APITypes.Scalars["String"]["input"];
  reservationId: APITypes.Scalars["String"]["input"];
}>;

export type RetryPaymentMutation = {
  retryPayment: {
    amount: number;
    appliedDiscount: number;
    currency: string;
    id: string;
    paymentMethodId?: string | null;
    paymentUpdateDate?: string | null;
    status: APITypes.PaymentStatus;
    stripePaymentNextStep?:
      | {
          clientSecret: string;
          paymentIntentId: string;
          redirectUrl: string;
          type: APITypes.PaymentActionType;
        }
      | {
          clientSecret: string;
          paymentIntentId: string;
          stripeSdkData: string;
          type: APITypes.PaymentActionType;
        }
      | null;
  };
};

export type ConfirmPaymentMutationVariables = APITypes.Exact<{
  paymentId: APITypes.Scalars["String"]["input"];
}>;

export type ConfirmPaymentMutation = {
  confirmPayment: {
    amount: number;
    appliedDiscount: number;
    currency: string;
    id: string;
    paymentMethodId?: string | null;
    paymentUpdateDate?: string | null;
    status: APITypes.PaymentStatus;
    stripePaymentNextStep?:
      | {
          clientSecret: string;
          paymentIntentId: string;
          redirectUrl: string;
          type: APITypes.PaymentActionType;
        }
      | {
          clientSecret: string;
          paymentIntentId: string;
          stripeSdkData: string;
          type: APITypes.PaymentActionType;
        }
      | null;
  };
};

export const CreatePaymentMethodDocument = gql`
    mutation CreatePaymentMethod($paymentMethodToken: String!) {
  createPaymentMethod(paymentMethodToken: $paymentMethodToken)
}
    `;
export type CreatePaymentMethodMutationFn = Apollo.MutationFunction<
  CreatePaymentMethodMutation,
  CreatePaymentMethodMutationVariables
>;

/**
 * __useCreatePaymentMethodMutation__
 *
 * To run a mutation, you first call `useCreatePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentMethodMutation, { data, loading, error }] = useCreatePaymentMethodMutation({
 *   variables: {
 *      paymentMethodToken: // value for 'paymentMethodToken'
 *   },
 * });
 */
export function useCreatePaymentMethodMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePaymentMethodMutation,
    CreatePaymentMethodMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>(
    CreatePaymentMethodDocument,
    options,
  );
}
export type CreatePaymentMethodMutationHookResult = ReturnType<
  typeof useCreatePaymentMethodMutation
>;
export type CreatePaymentMethodMutationResult = Apollo.MutationResult<CreatePaymentMethodMutation>;
export type CreatePaymentMethodMutationOptions = Apollo.BaseMutationOptions<
  CreatePaymentMethodMutation,
  CreatePaymentMethodMutationVariables
>;
export const CheckoutPaymentVerificationDocument = gql`
    mutation CheckoutPaymentVerification($input: VerifyCheckoutPaymentMethodInput!) {
  checkoutPaymentVerification(input: $input) {
    nextStep {
      clientSecret
      paymentIntentId
      redirectUrl
      type
    }
    requiresAdditionalActions
    confirmed
  }
}
    `;
export type CheckoutPaymentVerificationMutationFn = Apollo.MutationFunction<
  CheckoutPaymentVerificationMutation,
  CheckoutPaymentVerificationMutationVariables
>;

/**
 * __useCheckoutPaymentVerificationMutation__
 *
 * To run a mutation, you first call `useCheckoutPaymentVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutPaymentVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutPaymentVerificationMutation, { data, loading, error }] = useCheckoutPaymentVerificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckoutPaymentVerificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CheckoutPaymentVerificationMutation,
    CheckoutPaymentVerificationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CheckoutPaymentVerificationMutation,
    CheckoutPaymentVerificationMutationVariables
  >(CheckoutPaymentVerificationDocument, options);
}
export type CheckoutPaymentVerificationMutationHookResult = ReturnType<
  typeof useCheckoutPaymentVerificationMutation
>;
export type CheckoutPaymentVerificationMutationResult =
  Apollo.MutationResult<CheckoutPaymentVerificationMutation>;
export type CheckoutPaymentVerificationMutationOptions = Apollo.BaseMutationOptions<
  CheckoutPaymentVerificationMutation,
  CheckoutPaymentVerificationMutationVariables
>;
export const RemovePaymentMethodDocument = gql`
    mutation RemovePaymentMethod($paymentMethodId: String!) {
  removePaymentMethod(paymentMethodId: $paymentMethodId)
}
    `;
export type RemovePaymentMethodMutationFn = Apollo.MutationFunction<
  RemovePaymentMethodMutation,
  RemovePaymentMethodMutationVariables
>;

/**
 * __useRemovePaymentMethodMutation__
 *
 * To run a mutation, you first call `useRemovePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePaymentMethodMutation, { data, loading, error }] = useRemovePaymentMethodMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useRemovePaymentMethodMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemovePaymentMethodMutation,
    RemovePaymentMethodMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemovePaymentMethodMutation, RemovePaymentMethodMutationVariables>(
    RemovePaymentMethodDocument,
    options,
  );
}
export type RemovePaymentMethodMutationHookResult = ReturnType<
  typeof useRemovePaymentMethodMutation
>;
export type RemovePaymentMethodMutationResult = Apollo.MutationResult<RemovePaymentMethodMutation>;
export type RemovePaymentMethodMutationOptions = Apollo.BaseMutationOptions<
  RemovePaymentMethodMutation,
  RemovePaymentMethodMutationVariables
>;
export const AuthorizePaymentDocument = gql`
    mutation AuthorizePayment($paymentId: String!) {
  authorizePayment(paymentId: $paymentId) {
    ...Payment
  }
}
    ${PaymentFragmentDoc}`;
export type AuthorizePaymentMutationFn = Apollo.MutationFunction<
  AuthorizePaymentMutation,
  AuthorizePaymentMutationVariables
>;

/**
 * __useAuthorizePaymentMutation__
 *
 * To run a mutation, you first call `useAuthorizePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthorizePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authorizePaymentMutation, { data, loading, error }] = useAuthorizePaymentMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useAuthorizePaymentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AuthorizePaymentMutation,
    AuthorizePaymentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AuthorizePaymentMutation, AuthorizePaymentMutationVariables>(
    AuthorizePaymentDocument,
    options,
  );
}
export type AuthorizePaymentMutationHookResult = ReturnType<typeof useAuthorizePaymentMutation>;
export type AuthorizePaymentMutationResult = Apollo.MutationResult<AuthorizePaymentMutation>;
export type AuthorizePaymentMutationOptions = Apollo.BaseMutationOptions<
  AuthorizePaymentMutation,
  AuthorizePaymentMutationVariables
>;
export const RetryPaymentDocument = gql`
    mutation RetryPayment($paymentId: String, $stripePaymentMethodId: String!, $reservationId: String!) {
  retryPayment(
    paymentId: $paymentId
    stripePaymentMethodId: $stripePaymentMethodId
    reservationId: $reservationId
  ) {
    ...Payment
  }
}
    ${PaymentFragmentDoc}`;
export type RetryPaymentMutationFn = Apollo.MutationFunction<
  RetryPaymentMutation,
  RetryPaymentMutationVariables
>;

/**
 * __useRetryPaymentMutation__
 *
 * To run a mutation, you first call `useRetryPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryPaymentMutation, { data, loading, error }] = useRetryPaymentMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *      stripePaymentMethodId: // value for 'stripePaymentMethodId'
 *      reservationId: // value for 'reservationId'
 *   },
 * });
 */
export function useRetryPaymentMutation(
  baseOptions?: Apollo.MutationHookOptions<RetryPaymentMutation, RetryPaymentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RetryPaymentMutation, RetryPaymentMutationVariables>(
    RetryPaymentDocument,
    options,
  );
}
export type RetryPaymentMutationHookResult = ReturnType<typeof useRetryPaymentMutation>;
export type RetryPaymentMutationResult = Apollo.MutationResult<RetryPaymentMutation>;
export type RetryPaymentMutationOptions = Apollo.BaseMutationOptions<
  RetryPaymentMutation,
  RetryPaymentMutationVariables
>;
export const ConfirmPaymentDocument = gql`
    mutation ConfirmPayment($paymentId: String!) {
  confirmPayment(paymentId: $paymentId) {
    ...Payment
  }
}
    ${PaymentFragmentDoc}`;
export type ConfirmPaymentMutationFn = Apollo.MutationFunction<
  ConfirmPaymentMutation,
  ConfirmPaymentMutationVariables
>;

/**
 * __useConfirmPaymentMutation__
 *
 * To run a mutation, you first call `useConfirmPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmPaymentMutation, { data, loading, error }] = useConfirmPaymentMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useConfirmPaymentMutation(
  baseOptions?: Apollo.MutationHookOptions<ConfirmPaymentMutation, ConfirmPaymentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ConfirmPaymentMutation, ConfirmPaymentMutationVariables>(
    ConfirmPaymentDocument,
    options,
  );
}
export type ConfirmPaymentMutationHookResult = ReturnType<typeof useConfirmPaymentMutation>;
export type ConfirmPaymentMutationResult = Apollo.MutationResult<ConfirmPaymentMutation>;
export type ConfirmPaymentMutationOptions = Apollo.BaseMutationOptions<
  ConfirmPaymentMutation,
  ConfirmPaymentMutationVariables
>;
